export default "__VITE_ASSET__BskWNRWs__"